import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2",
        ul: "ul",
        li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'Thank you for visiting asadatik.dev ("the Website"). This privacy policy outlines how Asaduzzaman Atik ("I," "me," "my," or "mine") collect, use, and protect any personal information you provide while using this website. By accessing and using asadatik.dev, you acknowledge and agree to the terms of this privacy policy. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. Personal Information I Collect ✉️"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I may collect the following personal information from you through the use of the contact form and the download CV feature:"
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Name"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Email address (if provided in the contact form)"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Message content (if provided in the contact form)"
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. Use of Personal Information 📝"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I may use the personal information provided to:"
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Respond to your inquiries and messages sent through the contact form."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Share my CV with you if you request it through the download CV feature."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Contact you if necessary to fulfill your CV request or respond to your inquiry."
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Data Security 🔒"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I am committed to ensuring that your personal information is secure. To prevent unauthorized access or disclosure, I have implemented appropriate physical, electronic, and managerial procedures to safeguard and secure the information collected online."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Google Tag Manager 📊"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I use Google Tag Manager to track user interactions on the Website. This helps me understand how visitors engage with the site to improve its content and user experience. However, I do not collect any personally identifiable information through this tracking."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "5. Visitor Footprint 👣"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I do not share any visitor footprint or personally identifiable information with third parties or any other external entities."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "6. Hidden Information 🙈"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Certain personal information, such as my birthday, personal email, and address, is hidden from the Website for security purposes. If you wish to obtain this information, you may contact me through the provided contact form. I will share this information only after communicating with you and verifying your identity."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "7. Age Restriction 🧒👦"
            }),
            "\n",
            _jsx(_components.p, {
                children: "The Website is accessible to users of all ages. However, if you are under the age of 13, please do not provide any personal information through the contact form without parental or guardian consent."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "8. Third-Party Links 🌐"
            }),
            "\n",
            _jsx(_components.p, {
                children: "The Website may contain links to third-party websites. Please note that I do not have control over these external sites, and this privacy policy does not apply to them. Once you leave asadatik.dev, I am not responsible for the protection and privacy of any information you provide on other sites. Please exercise caution and review the privacy policies of those websites."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "9. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "For any privacy-related inquiries or to exercise your rights regarding your personal information, please contact me at asadatik.me@gmail.com."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "10. Changes to this Privacy Policy 🔄"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I may update this privacy policy from time to time to reflect changes in my practices or for other operational, legal, or regulatory reasons. Any changes will be effective immediately upon posting the updated policy on the Website. Please review this page periodically for the latest information on my privacy practices."
            }),
            "\n",
            _jsx(_components.p, {
                children: "By continuing to use asadatik.dev, you signify your acceptance of this privacy policy. If you do not agree with any part of this policy, please refrain from using the Website."
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
